import { ENDPOINTS } from './endpoints';
import { bindLocaleIntoHeaders } from '../utils/resolve-locale';
import { fetchData } from './network';

export function getDonate() {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.getDonateFoundations.path}`);
  bindLocaleIntoHeaders(url);
  url.searchParams.append('populate', '*');

  return fetchData(url, {
    method: ENDPOINTS.getDonateFoundations.method
  }).then((response) => response);
}

export function getDonatationToken(data) {
  const url = new URL(`${process.env.DJANGO_URL}${ENDPOINTS.DonateNow.path}/`);

  return fetchData(url, {
    method: ENDPOINTS.DonateNow.method,
    body: JSON.stringify({ ...data, amount: Number(data.amount) })
  }).then((response) => response);
}

export function submitDonatationForm(data) {
  const url = new URL(`${process.env.API_URL}${ENDPOINTS.DonationForm.path}/`);

  return fetchData(url, {
    method: ENDPOINTS.DonationForm.method,
    body: JSON.stringify({
      data: {
        ...data,
        phone: `${data.phone}`
      }
    })
  }).then((response) => response);
}
